<style scoped>
.chart-parameters {
  min-height: 500px;
}

.v-input {
  font-size: 10px;
}

.v-input__slot {
  margin-bottom: 0px;
}

.v-text-field {
  padding-top: 2px;
  margin-top: 1px;
}

.v-list__tile {
  font-size: 11px !important;
  height: 28px !important;
}

.v-label {
  font-size: 12px !important;
}

.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
  font-size: 12px;
  font-size: 12px !important;
}

.v-label {
  font-size: 12px !important;
  line-height: 1;
  min-height: 8px;
  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.bg-cover {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
</style>

<template>
  <v-container grid-list-xs fluid ma-0 pa-0 class="bg">
    <v-layout row wrap ma-0 pa-0 class="bg">
      <v-menu style="" v-model="menu" :close-on-content-click="false" :close-on-click="false" :nudge-width="200" offset-x>
        <template v-slot:activator="{ on }">
          <v-btn
            dark
            icon
            color="primary"
            small
            style="position: absolute; right: 0px; top: 20px; z-index: 5;"
            v-on="on"
          >
            <v-icon>menu</v-icon>
          </v-btn>
        </template>
        <div
          class="text-xs-center"
          xs12
          sm5
          md3
          style="width: 450px; height: 900px; z-index: 10000; "
        >
          <v-layout>
            <v-flex xs12>
              <v-card style="padding: 10px; padding-top: 50px;" class="bg">
                <v-layout row wrap ma-0 pa-0>
                  <v-flex xs12>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          flat
                          color="blue"
                          v-on="on"
                          style="position: absolute; left: 0px; top: 0px;"
                          @click="selectChart = !selectChart"
                        >
                          <v-icon>insert_chart_outlined</v-icon>Change Chart
                        </v-btn>
                      </template>
                      <span>Change Chart</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          flat
                          icon
                          color="blue"
                          v-on="on"
                          style="position: absolute; right: 70px; top: 0px;"
                          @click="aCopyGrid(grid)"
                        >
                          <v-icon>file_copy</v-icon>
                        </v-btn>
                      </template>
                      <span>Copy Chart</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          flat
                          icon
                          color="red"
                          v-on="on"
                          v-on:click="menu = false; closeChart(activeLayer)"
                          style="position: absolute; right: 10px; top: 0px;"
                        >
                          <v-icon>close</v-icon>
                        </v-btn>
                      </template>
                      <span>Close</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout row wrap ma-0 pa-0 v-if="selectChart || activeLayer.type == 'blank'">
                      <v-flex
                        class="xs6 d-flex"
                        :key="chartType.id"
                        v-for="chartType in chartTypes"
                        style="cursor: pointer;"
                        @click="setChart(chartType)"
                      >
                        <div
                          class="v-card v-sheet theme--light"
                          :style="'background: url( ' + chartType.icon + ') -2px 30px no-repeat; width; 100%; height: 200px;'"
                        >
                          <!--<v-img :src="chartType.icon" aspect-ratio="1"></v-img>-->
                          <v-card-actions>
                            <v-btn flat color="grey">{{ chartType.title }}</v-btn>
                          </v-card-actions>
                        </div>
                      </v-flex>
                    </v-layout>

                    <v-layout v-else row wrap ma-0 pa-0>
                      <template>
                        <v-expansion-panel ma-0 pa-0>

                          <v-expansion-panel-content
                            v-for="(group,i) in activeLayer.parameterGroups"
                            :key="i"
                            :expand="group.name == activeParameterGroupId"
            
                          >
                            <template v-slot:header style="padding: 6px; 6px">
                              <div class="subheading">{{ group.name }}</div>
                            </template>
                            <v-layout row wrap ma-0 style="padding-left: 15px" v-if="group.id == 'form.builder'">
                                <properties v-if="activeLayer" :chart="activeLayer" :tab="activeLayer.tab"></properties> 
                            </v-layout>
                            <v-layout row wrap ma-0 style="padding-left: 15px" v-if="group.id != 'form.builder'">
                              <template v-for="(parameter, key) in activeLayer.parameters">
                                <v-flex
                                  ma-0
                                  pa-0
                                  :class="parameter.class"
                                  v-if="(typeof parameter.groupId == 'undefined' && group.id == 'default') || parameter.groupId == group.id"
                                  :key="'parameter' + key"
                                >
                                  <v-text-field
                                    v-if="parameter.type == 'input'"
                                    v-model="parameter.value"
                                    :label="parameter.label"
                                    v-on:blur="aChanged(parameter)"
                                  ></v-text-field>
                                  <v-textarea
                                    v-if="parameter.type == 'textarea'"
                                    v-model="parameter.value"
                                    :label="parameter.label"
                                    v-on:blur="aChanged(parameter)"
                                  ></v-textarea>
                                  <v-textarea
                                    v-if="parameter.type == 'code'"
                                    v-model="parameter.value"
                                    :label="parameter.label"
                                    v-on:click="openDialog(parameter)"
                                  ></v-textarea>
                                  <v-text-field :label="parameter.label" v-if="parameter.type == 'colorPicker'" v-model="parameter.value" v-on:click="setColorParameter(parameter)"></v-text-field>
                                  <v-select
                                    v-show="!parameter.wait"
                                    v-if="parameter.type == 'select'"
                                    :clearable="true"
                                    :items="parameter.items"
                                    :item-value="parameter.itemValue"
                                    :item-text="parameter.itemText"
                                    :label="parameter.label"
                                    v-model="parameter.value"
                                    v-on:change="aChanged(parameter)"
                                  ></v-select>
                                  <v-select
                                    v-show="!parameter.wait"
                                    v-if="parameter.type == 'multi-select'"
                                    :items="parameter.items"
                                    :item-value="parameter.itemValue"
                                    :item-text="parameter.itemText"
                                    :label="parameter.label"
                                    v-model="parameter.value"
                                    multiple
                                    v-on:change="aChanged(parameter)"
                                  ></v-select>
                                  <v-slider
                                    v-if="parameter.type == 'slider'"
                                    :min="0"
                                    thumb-label="always"
                                    v-model="parameter.value"
                                    :label="parameter.label"
                                    v-on:end="aChanged(parameter)"
                                  ></v-slider>
                                  <v-switch
                                    v-if="parameter.type == 'switch'"
                                    v-model="parameter.value"
                                    :label="parameter.label"
                                    v-on:change="aChanged(parameter)"
                                  ></v-switch>
                                </v-flex>
                              </template>
                            </v-layout>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </template>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-actions v-if="mode != 'view'">
                      <v-spacer></v-spacer>
                      <v-btn color @click="aRemoveGrid(grid)">Delete</v-btn>
                    </v-card-actions>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </div>
      </v-menu>
    </v-layout>
    <v-dialog
      v-model="dialog"
      :persistent="true"
      width="800"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Code Editor
        </v-card-title>

        <v-card-text style="height: 700px">
          <ace-editor style="height: 100%" v-if="dialogParameter" v-model="code" @init="editorInit" :lang="lang" theme="chrome" width="100%" height="200"></ace-editor>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="cancel()"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            flat
            @click="save()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="colorDialog"
      :persistent="true"
      width="400"
    >
      <v-card v-if="colorParameter">
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          {{ colorParameter.label }}
        </v-card-title>

        <v-card-text style="height: auto">
          <v-text-field :label="colorParameter.label" v-model="colorParameter.value"></v-text-field>
          <sketch-picker v-model="colors" @input="updateColor" />
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="colorDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            flat
            @click="saveColor()"
          >
            Update 
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import VueAceEditor from 'vue2-ace-editor';
import 'brace/ext/language_tools';
import 'brace/mode/sql';
import 'brace/mode/html';
import 'brace/mode/css';
import 'brace/mode/javascript';
import 'brace/mode/json';
import 'brace/theme/chrome';

// import beautify from "brace/ext/beautify";

// has mapState, mapActions, mapGetters, mapMutations
const dataSourceNamespace = createNamespacedHelpers("dataSources");
const chartNamespace = createNamespacedHelpers("charts");

const Properties = () => import('@/components/charts/form/builder/properties.vue');

import { Photoshop, Swatches, Twitter, Sketch } from "vue-color";


function resolve(path, obj) {
  return path.split(".").reduce(function (prev, curr) {
    return prev ? prev[curr] : null;
  }, obj || self);
}

export default {
  props: ["chart", "grid", "mode"],
  data: function () {
    return {
      activeParameterGroupId: "default",
      colors: [],
      selectChart: false,
      chartType: null,
      code: null,
      fav: true,
      menu: false,
      message: false,
      hints: true,
      clickedChart: null,
      dialog: false,
      dialogParameter: null,
      editor: null,
      lang: 'sql',
      colorDialog: false,
      colorParameter: null,
      colors: {},
    };
  },
  methods: {
    ...chartNamespace.mapMutations([
      "mToggleGridMenu",
      "mToggleEditable",
      "mSetType",
      "mSetActiveLayerType",
      "mSetLayerType",
      "mLoadActiveLayer",
      "mChangeChart",
      "mSetChangeChart",
      "mLoadParametersAndHydrator",
    ]),
    ...chartNamespace.mapActions(["aChanged", "aRemoveGrid", "aCopyGrid"]),
    setColorParameter(parameter) {
      this.colorParameter = parameter;
      this.colors = {hex: parameter.value};
      this.colorDialog = true;
    },
    saveColor() {
      console.log("colors", this.colors);
      if(this.colorParameter) {
        this.colorParameter.value = this.colors.hex;
        this.aChanged(this.colorParameter);
      }
      this.colorDialog = false;
      
    },
    updateColor (value) {
      // console.log("value", value);
      // this.colors = value
    },
    closeChart(chart) {
      // if(typeof chart.save != "undefined") {
      //   try {
      //     chart.save();
      //   } catch(error) {

      //   }
      // }
    },
    save() {
      this.dialog = false;
      this.dialogParameter.value = this.editor.getValue();
      this.aChanged(this.dialogParameter);
    },
    cancel() {
      this.dialog = false;
    },
    editorInit: function (editor) {
          editor.setOptions({
            enableBasicAutocompletion: true
          });
          // beautify.beautify(editor.session);
          this.editor = editor;
          // this.code = this.dataSource.input;
          // this.mSetAceEditor(editor);
    },
    openDialog(parameter) {
      this.dialogParameter = parameter;
      this.code = parameter.value;
      this.dialog = true;
      if(typeof parameter.lang && parameter.lang) {
        this.lang = parameter.lang;
      } else {
        this.lang = 'sql';
      }
    },
    closeDialog() {
      this.dialog = false;
    },
    setChart(chart) {
      this.clickedChart = chart;
      this.selectChart = false;
      console.log("set chart", chart);
      
      // this.mSetActiveLayerType(chart.id);
      this.mChangeChart(chart.id);
      this.mLoadParametersAndHydrator(this.activeLayer);
    },
    activateParameterGroupId: function (group) {
      this.activeParameterGroupId = group.id;
    },
    isParameterGroupActive: function (group) {
      if (
        this.activeParameterGroup &&
        this.activeParameterGroup.id == group.id
      ) {
        return true;
      }
      return false;
    },
  },
  computed: {
    // ...dataSourceNamespace.mapState(['dataSources']),
    ...chartNamespace.mapState({
      // chart: state => state.chart,
      activeLayer: (state) => state.activeLayer,
      chartTypes: (state) => state.chartTypes,
      editable: (state) => state.editable,
    }),
  },
  components: {
    "swatches-picker": Swatches,
    "twitter-picker": Twitter,
    "sketch-picker": Sketch,
    "properties": Properties,
    'ace-editor': VueAceEditor
  },
  mounted: function () {
    const _this = this;
    
    setTimeout(function () {
      // console.log("this.loadDataSources()");
      // console.log(_this.chart);
      //  _this.loadDataSources();
      // console.log("this.loadDefaults()");
      //  _this.loadDefaults();
      // console.log("_this.chart");
      // console.log(_this.chart);
    }, 1000);

    // console.log(this.chart);
  },
};
</script>
